<div class="a00150 a00150--{{ modifier }}">
    <a
        href="mailto:{{ email }}"
        class="mail"
        *ngIf="modifier === A00150ContactLinksType.D"
    >
        <span
            [inlineSVG]="
                '/assets/icons/mail.svg' | assetPath
            "
        ></span>
    </a>
    <a
        href="tel:{{ phone }}"
        class="phone"
        *ngIf="
            modifier === A00150ContactLinksType.A ||
            modifier === A00150ContactLinksType.B ||
            modifier === A00150ContactLinksType.D
        "
    >
        <span
            [inlineSVG]="
                '/assets/icons/phone.svg' | assetPath
            "
        ></span>
        {{ phone }}
    </a>
    <a
        href="mailto:{{ email }}"
        class="mail"
        *ngIf="modifier === A00150ContactLinksType.C"
    >
        <span
            [inlineSVG]="
                '/assets/icons/mail.svg' | assetPath
            "
        ></span>
        {{ email }}
    </a>
</div>
